import { whyReasons } from '@/mocks/homeContent';

export default function WhySection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs md:text-sm text-foreground-500 font-medium uppercase tracking-wider mb-2">
          Why Trust Us
        </p>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-4 leading-tight">
          Smarter Shopping<br />With Spreadsheets
        </h2>
        <p className="text-foreground-600 text-sm md:text-base max-w-xl mb-12">
          Shopping without a spreadsheet can be overwhelming. An AllChinaBuy Spreadsheet helps buyers discover products faster, compare categories, locate trusted sellers, and organize purchases efficiently.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {whyReasons.map((reason) => (
            <div
              key={reason.title}
              className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <span className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
                <i className={`${reason.icon} text-primary-600 text-xl`}></i>
              </span>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {reason.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}